import { Component, HostListener } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { Constanst } from 'src/app/core/constants/constans.component';
import { CachePartidasService } from 'src/app/core/services/cache-partidas-service';
import { MatDialog } from '@angular/material/dialog';
import { CambiarFechaBdPresupuestoComponent } from 'src/app/components/presupuestos/admin-configuracion/cambiar-fecha-bd-presupuesto/cambiar-fecha-bd-presupuesto.component';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';

@Component({
  selector: 'app-menu-principal',
  templateUrl: './menu-principal.component.html',
  styleUrls: ['./menu-principal.component.css']
})
export class MenuPrincipalComponent {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  username: string | null = this.localStorageService.getItem(Constanst.STORAGE_DATA_USERNAME);
  userprofile: string | null = (this.localStorageService.getItem(Constanst.STORAGE_DATA_PROFILE) != null ? this.localStorageService.getItem(Constanst.STORAGE_DATA_PROFILE) : '2');
  viewScreen: string | null = (localStorage.getItem(Constanst.STORAGE_DATA_SCREENTYPE) != null ? localStorage.getItem(Constanst.STORAGE_DATA_SCREENTYPE) : Constanst.SCREEN_TYPE_BD);

  isHandset$: Observable<boolean> = this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  private inactivityTimeout = 15 * 60 * 1000; // 15 minutos en milisegundos
  private inactivityTimer: number;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService,
    private cachePartidasService: CachePartidasService,
    public openDialogs: MatDialog,
    public dialogCambiarFechaBdPresupuesto: MatDialog,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit(): void {
    //this.resetInactivityTimer();
  }

  ngOnDestroy() {
    window.clearTimeout(this.inactivityTimer);
  }

  // Detectar movimiento del mouse para reiniciar el temporizador
  @HostListener('window:mousemove', ['$event'])
  onUserActivity() {
    this.resetInactivityTimer();
  }

  navigateMenu(tag: string) {
      this.router.navigate(['/' + tag]);
  }

  confirmLogout() {
    const dialog = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONFIRM_LOGOUT, true, true, false, Constanst.DIALOG_ACTIONBTCANCEL, Constanst.DIALOG_ACTIONBTACCEPT, '', Constanst.DIALOG_RESULT_INFO);
    dialog.afterClosed().subscribe((result: string) => {
      if (result === Constanst.DIALOG_RESULT_ACTION) {
        this.logout();
      } else {
        dialog.close(false);
      }
    });
  }

  logout() {
    this.route = '/logout';
    this.method = 'POST';

    let data = {
      idUser: this.localStorageService.getItem(Constanst.STORAGE_DATA_USER)
    }

    this.apiCallService.call$(data, this.route, this.method, true, '', true)
    .pipe(takeUntil(this.destroy$)).subscribe(
      response => {
        //console.log(response);
        if (response.status === 'SUCCESS') {
          window.clearTimeout(this.inactivityTimer);
          this.helperClassService.localStorageClear();
          this.cachePartidasService.clear();
          this.router.navigate(['/login']);
          this.apiCallService.hideSpinner();
        }
      }
    );
  }

  // Reiniciar el temporizador de inactividad
  resetInactivityTimer() {
    window.clearTimeout(this.inactivityTimer);
    this.inactivityTimer = window.setTimeout(() => this.handleSessionExpiration(), this.inactivityTimeout);
  }

  // Manejar la expiración de sesión por inactividad
  handleSessionExpiration() {
    this.closedialogs();
    this.logout();
    this.apiCallService.hideSpinner();
    this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_EXPIRED_SESSION, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
  }

  navigateMenuPresupuesto() {
    localStorage.setItem(Constanst.STORAGE_DATA_SCREENTYPE, Constanst.SCREEN_TYPE_PS);
    this.router.navigate(['/presupuestos']);
  }

  navigateMenuBaseDatos() {
    const dialogSalirPresupuesto = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONFIRM_EXIT_BUDGET, true, true, false, Constanst.DIALOG_ACTIONBTCANCEL, Constanst.DIALOG_ACTIONBTACCEPT, '', Constanst.DIALOG_RESULT_INFO);
    dialogSalirPresupuesto.afterClosed().subscribe((result: string) => {
      if (result === Constanst.DIALOG_RESULT_ACTION) {
        this.cachePartidasService.clear();
        localStorage.removeItem(Constanst.STORAGE_DATA_BUDGETSELECT);
        localStorage.setItem(Constanst.STORAGE_DATA_SCREENTYPE, Constanst.SCREEN_TYPE_BD);
      this.router.navigate(['menu']);
      } else {
        dialogSalirPresupuesto.close(false);
      }
    });
  }

  public isExpanded = false;

  public toggleMenu() {
    this.isExpanded = !this.isExpanded;
  }

  private closedialogs() {
    this.openDialogs.closeAll();
  }

  cambiarFechasBdPresupuesto() {
    this.dialogCambiarFechaBdPresupuesto.open(CambiarFechaBdPresupuestoComponent, { width: '45rem' });
  }

}
